export default {
  'createbusinessprofile.createbusinessprofile': 'إنشاء ملف تعريف تجاري',
};
